// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PaymentMethods_container__039Z8 {
  width: 85%;
  padding: 30px;
  margin-left: auto;
  text-align: left;
}

.PaymentMethods_toggle__A9wGy {
  position: relative;
  display: inline-block;
  width: 50px;
  height: 26px;
}

.PaymentMethods_toggle__A9wGy input {
  opacity: 0;
  width: 0;
  height: 0;
}

.PaymentMethods_slider__IUEWh {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: all 0.3s ease;
  border-radius: 26px;
  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);
}

.PaymentMethods_slider__IUEWh:before {
  position: absolute;
  content: "";
  height: 20px;
  width: 20px;
  left: 3px;
  bottom: 3px;
  background-color: white;
  transition: all 0.3s ease;
  border-radius: 50%;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.PaymentMethods_toggle__A9wGy input:checked + .PaymentMethods_slider__IUEWh {
  background-color: rgba(29, 135, 82, 1);
  box-shadow: 0 0 4px rgba(29, 135, 82, 0.5);
}

.PaymentMethods_toggle__A9wGy input:checked + .PaymentMethods_slider__IUEWh:before {
  transform: translateX(24px);
}

.PaymentMethods_add__6xvTW {
  position: absolute;
  top: 1.4rem;
  right: 2rem;
  background: rgba(29, 135, 82, 1);
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  font-size: 25px;
}

.PaymentMethods_title__SdiSo {
  font-size: 22px;
  font-weight: 600;
  margin-bottom: 20px;
  color: #333;
}

.PaymentMethods_tableWrapper__yrAdC {
  max-height: 27vw;
  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative; /* на всякий случай */
}

.PaymentMethods_table__Pk\\+l8 {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.05);
}

.PaymentMethods_table__Pk\\+l8 thead th {
  position: sticky;
  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */
  z-index: 5;
  background-color: #f9f9f9;
}

.PaymentMethods_page__OuY6i {
  color: red;
}
.PaymentMethods_table__Pk\\+l8 th,
.PaymentMethods_table__Pk\\+l8 td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.PaymentMethods_table__Pk\\+l8 th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.PaymentMethods_table__Pk\\+l8 tr:hover {
  background-color: #f5f5f5;
}

.PaymentMethods_active__mQ4sD {
  color: #1eae60;
  font-weight: 600;
}

.PaymentMethods_inactive__lMUzN {
  color: #d9534f;
  font-weight: 600;
}

.PaymentMethods_settingsBtn__NX4\\+w {
  background: transparent;
  border: none;
  cursor: pointer;
  color: #555;
  transition: color 0.2s;
}

.PaymentMethods_settingsBtn__NX4\\+w:hover {
  color: red;
}
`, "",{"version":3,"sources":["webpack://./src/styles/PaymentMethods.module.css"],"names":[],"mappings":"AAAA;EACE,UAAU;EACV,aAAa;EACb,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,sBAAsB;EACtB,yBAAyB;EACzB,mBAAmB;EACnB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,yBAAyB;EACzB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,sCAAsC;EACtC,0CAA0C;AAC5C;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,gBAAgB,EAAE,+CAA+C;EACjE,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB,EAAE,qBAAqB;AAC3C;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,sCAAsC;AACxC;;AAEA;EACE,gBAAgB;EAChB,MAAM,EAAE,2DAA2D;EACnE,UAAU;EACV,yBAAyB;AAC3B;;AAEA;EACE,UAAU;AACZ;AACA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,UAAU;AACZ","sourcesContent":[".container {\n  width: 85%;\n  padding: 30px;\n  margin-left: auto;\n  text-align: left;\n}\n\n.toggle {\n  position: relative;\n  display: inline-block;\n  width: 50px;\n  height: 26px;\n}\n\n.toggle input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: #ccc;\n  transition: all 0.3s ease;\n  border-radius: 26px;\n  box-shadow: inset 0 0 3px rgba(0, 0, 0, 0.2);\n}\n\n.slider:before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  width: 20px;\n  left: 3px;\n  bottom: 3px;\n  background-color: white;\n  transition: all 0.3s ease;\n  border-radius: 50%;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);\n}\n\n.toggle input:checked + .slider {\n  background-color: rgba(29, 135, 82, 1);\n  box-shadow: 0 0 4px rgba(29, 135, 82, 0.5);\n}\n\n.toggle input:checked + .slider:before {\n  transform: translateX(24px);\n}\n\n.add {\n  position: absolute;\n  top: 1.4rem;\n  right: 2rem;\n  background: rgba(29, 135, 82, 1);\n  color: white;\n  padding: 5px 20px;\n  border-radius: 5px;\n  font-size: 25px;\n}\n\n.title {\n  font-size: 22px;\n  font-weight: 600;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n.tableWrapper {\n  max-height: 27vw;\n  overflow-y: auto; /* важен для «липкой» шапки внутри контейнера */\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  position: relative; /* на всякий случай */\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0,0,0,0.05);\n}\n\n.table thead th {\n  position: sticky;\n  top: 0; /* расстояние от верхней границы контейнера .tableWrapper */\n  z-index: 5;\n  background-color: #f9f9f9;\n}\n\n.page {\n  color: red;\n}\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.active {\n  color: #1eae60;\n  font-weight: 600;\n}\n\n.inactive {\n  color: #d9534f;\n  font-weight: 600;\n}\n\n.settingsBtn {\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #555;\n  transition: color 0.2s;\n}\n\n.settingsBtn:hover {\n  color: red;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `PaymentMethods_container__039Z8`,
	"toggle": `PaymentMethods_toggle__A9wGy`,
	"slider": `PaymentMethods_slider__IUEWh`,
	"add": `PaymentMethods_add__6xvTW`,
	"title": `PaymentMethods_title__SdiSo`,
	"tableWrapper": `PaymentMethods_tableWrapper__yrAdC`,
	"table": `PaymentMethods_table__Pk+l8`,
	"page": `PaymentMethods_page__OuY6i`,
	"active": `PaymentMethods_active__mQ4sD`,
	"inactive": `PaymentMethods_inactive__lMUzN`,
	"settingsBtn": `PaymentMethods_settingsBtn__NX4+w`
};
export default ___CSS_LOADER_EXPORT___;
